<template>
  <span class="cart-quantity">
    <button @click="decrement()" ref="minus" ><icon-minus :fill="fillMinus"></icon-minus></button>
    <input type="number" :value="value" readonly ref="quantity-number">
    <button @click="increment()" ref="plus"><icon-plus></icon-plus></button>
  </span>
</template>
<script>
  import IconPlus from "./icons/IconPlus";
  import IconMinus from "./icons/IconMinus";
  export default {
    name: 'CartQuantity',
    components: {
      IconPlus,
      IconMinus
    },
    data() {
      return {
        quantity: 1,
        fillMinus: '#BC2030',
        fillActive: '#BC2030',
        fillInActive: '#E5E0DF',
      }
    },
    props: {
      value : Number
    },
    created() {

    },
    methods: {
      decrement () {
        let value = this.value
        if (value >= 2) {
          value--
        }
        if (value === 1) {
          this.fillMinus = this.fillInActive
          this.$refs.minus.disabled = true
        } else {
          this.fillMinus = this.fillActive
          this.$refs.minus.disabled = false
        }
        this.$emit('input',value)

      },
      increment () {
        let value = this.value
        value++
        if (value === 1) {
          this.fillMinus = this.fillInActive
          this.$refs.minus.disabled = true
        } else {
          this.fillMinus = this.fillActive
          this.$refs.minus.disabled = false
        }
        this.$emit('input',value)
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CartQuantity.vue